import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Software Engineer",
          "Pioneering Solutions With Cutting Edge Technology",
          "Harnessing AI for Next-Gen Image and Video Solutions",
          "SQL Expert",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
